// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__3AvPi","actions":"style_actions__1VMil"};